import { CardProps } from "../interfaces/core";
import AudioVisualizer from "../pages/AudioVisualizer";
import SpikeGen from "../pages/SpikeGen";
import VideoConverter from "../pages/VideoConverter";

const projects: CardProps[] = [
  {
    video: {
      filename: "audio-visualizer",
      webm: true,
      mp4: true,
    },
    src: "/assets/images/thumbnails/audio-visualizer.webp",
    title: "Audio Visualizer",
    subtitle: "Microphone",
    description:
      "Generate beautiful patterns based on low, mid, and high pitches from the microphone.",
    exact: true,
    href: "/audio-visualizer",
    Page: AudioVisualizer,
  },
  {
    video: {
      filename: "spike-pie",
      webm: true,
      mp4: true,
    },
    src: "/assets/images/thumbnails/spike-pie.webp",
    title: "Spike Pie Generator",
    description:
      "Generate beautiful patterns based on low, mid, and high pitches from the microphone.",
    exact: true,
    href: "/spike-pie",
    Page: SpikeGen,
  },
  {
    src: "/assets/images/thumbnails/video-converter.webp",
    title: "Video Converter",
    subtitle: "Convert video pixels to anything",
    description:
      "Turning live camera into fun emojis or circles of all colors. More features coming soon...",
    exact: true,
    href: "/video-converter",
    Page: VideoConverter,
  },
];
export default projects;
